import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import Introduction from "./Introduction";
import Subsection1 from "./Subsection1";
import Subsection1b from "./Subsection1b";
import Subsection2 from "./Subsection2";
import Subsection3 from "./Subsection3";
import BreadcrumbNav from "../../navigation/Breadcrumb";
import BottomNavigation from "../../navigation/BottomNavigation";

interface PreEmptiveRetentionsProps {
  toggleSection: (section: string, open?: boolean) => void;
}

const PreEmptiveRetentions: FC<PreEmptiveRetentionsProps> = ({ toggleSection }) => {
  const { subsection } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [subsection]);

  useEffect(() => {
    toggleSection("Preemptive Retentions", true);
  }, [toggleSection])

  useEffect(() => {
    if (subsection === "proposed-changes" || subsection === "responses-to-other-prompts-proposed-changes") {
      toggleSection("Preemptive Retentions/Proposed Changes", true);
    }
  }, [toggleSection, subsection])

  return (
    <>
      <BreadcrumbNav section="preemptive-retentions" subsection={subsection} />

      <h1>Preemptive Retentions</h1>
      {subsection === "introduction" && <Introduction />}
      {subsection === "proposed-changes" && <Subsection1 />}
      {subsection === "responses-to-other-prompts-proposed-changes" && <Subsection1b />}
      {subsection === "comments-about-changes" && <Subsection2 />}
      {subsection === "additional-details-about-actions" && <Subsection3 />}

      <BottomNavigation />
    </>
  )
}

export default PreEmptiveRetentions;